const objectFitImages = require('object-fit-images');
const dialogPolyfill = require('dialog-polyfill');
const reframeJs = require('reframe.js/dist/jquery.reframe');
const svgxuse = require('svgxuse');

// Object Fit
objectFitImages();

// Html Dialog
if (typeof HTMLDialogElement === 'function') {
    console.log('Supports Dialog');
} else {
    console.log('Does Not Support Dialog');
    $('dialog').each(function () {
        dialogPolyfill.registerDialog(this);
    });
}

// Reframe iframes
$('iframe[src*=youtube]:not([class]), iframe[src*=vimeo]:not([class]), iframe[src*="google.com"]:not([class])').reframe();
